import Vue from "vue";

import EmptyTable from "@/components/EmptyTable.vue";

Vue.component("empty-table", EmptyTable);

